const dispatch = require("~/store.js").dispatch;
const server = require("~/server.js");

const events = require("./impersonationEvents.js");

const impersonationDispatchers = {
    StartImpersonating(account) {
        const transitionTypeName = `Start impersonating: ${account.Login}`;

        dispatch((thunkDispatch) => {
            const transitioning = events.Transitioning.New(transitionTypeName);

            thunkDispatch(transitioning);
            
            server.Put("current-user/alter-ego", account)
                .then(() => {
                    const transitioned = events.Transitioned.New(transitionTypeName);

                    thunkDispatch(transitioned);
                })
                .catch((ex) => {
                    const errored = events.TransitionErrored.New(transitionTypeName, ex);

                    thunkDispatch(errored);
                });
        });
    },
    StopImpersonating() {
        const transitionTypeName = "Stop impersonating";

        dispatch((thunkDispatch) => {
            const transitioning = events.Transitioning.New(transitionTypeName);

            thunkDispatch(transitioning);

            server.Delete("current-user/alter-ego")
                .then(() => {
                    const transitioned = events.Transitioned.New(transitionTypeName);

                    thunkDispatch(transitioned);
                })
                .catch((ex) => {
                    const errored = events.TransitionErrored.New(transitionTypeName, ex);

                    thunkDispatch(errored);
                });
        });
    }
};

module.exports = impersonationDispatchers;


// WEBPACK FOOTER //
// ./src/events/impersonation/impersonationDispatchers.js